<form id="form" [formGroup]="form" (submit)="confirm($event)">
  <div>
    <label for="name">Name</label>
    <div class="input-error-container">
      <input
        type="text"
        id="name"
        class="e-input"
        required
        [maxlength]="100"
        formControlName="name"
        trackable="Edit delivery/Recipient details/Name" />
      <div class="input-error" *ngIf="!form.get('name')?.value && displayErrors">Name is mandatory</div>
    </div>
  </div>

  <div>
    <label for="name">Email</label>
    <div class="input-error-container">
      <input
        type="text"
        id="email"
        class="e-input"
        [maxlength]="100"
        formControlName="email"
        trackable="Edit delivery/Recipient details/Email" />
      <div class="input-error" *ngIf="emailError && displayErrors">{{ emailError }}</div>
    </div>
  </div>

  <div>
    <label for="phone">Phone Number</label>
    <div class="input-error-container">
      <common-intl-phone-number
        controlName="phoneNumber"
        id="phone"
        [class.invalid]="phoneError"
        trackable="Edit delivery/Recipient details/Phone"></common-intl-phone-number>
      <div class="input-error" *ngIf="phoneError && displayErrors">{{ phoneError }}</div>
    </div>
  </div>
</form>
<div class="button-container">
  <button
    type="submit"
    id="submit-changes"
    form="form"
    [disabled]="form.pristine || loading"
    [style.color]="textColor"
    [style.background-color]="brandColor">
    Save changes
    <img *ngIf="loading" src="../assets/loading-circle-white-animated.svg" />
  </button>
</div>

<common-edit-order-contact-us-button
  [brandColor]="brandColor"
  [trackableText]="'Recipient details'"></common-edit-order-contact-us-button>
